import { useCallback, useEffect, useState } from "react";
import { client } from "../lib/axiosClient";
import Cookies from 'universal-cookie';

const cookies = new Cookies(null, { path: '/' });

interface Filter {
    idStore: string;
    productId?: string;
    state?: string;
    dateStart?: string;
    dateEnd?: string;
    status?: string;
    confirmedBy?: string;
}

export const useReportsProducts = () => {
    const [data, setData] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<any>(null);

    const fetchData = useCallback(async (filter: Filter) => {
        setLoading(true);
        try {
            const response = await client.get(`/reports/reportsProducts`, {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': cookies.get('token') || ""
                },
                params: filter
            });
            
            if (response.status !== 200) {
                throw new Error('Failed to fetch data');
            }
            setData(response?.data)
        } catch (error) {
            setError(error);
        } finally {
            setLoading(false);
        }
    }, []);
    
    const refetch = (filter: Filter) => {
        fetchData(filter);
    };

      
    return { data, loading, error, fetchData, refetch };
}